const GET_CATEGORY_LIST_ACTION = 'GET_CATEGORY_LIST_ACTION'
const GET_CATEGORY_LIST_ACTION_SUCCESS = 'GET_CATEGORY_LIST_ACTION_SUCCESS'

export { GET_CATEGORY_LIST_ACTION, GET_CATEGORY_LIST_ACTION_SUCCESS }
